/** True when the browser reports connectivity (best-effort in low-connectivity areas). */
export function isBrowserOnline() {
  return typeof navigator !== "undefined" ? navigator.onLine !== false : true;
}
